/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_ResponsibilityInputs */



/**
* | output |
* | --- |
* | "You are responsible for configuration and usage of the Guardrails feature." |
*
* @param {Guardrails_Short_ResponsibilityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_responsibility = /** @type {((inputs?: Guardrails_Short_ResponsibilityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_ResponsibilityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die Verantwortung für Konfiguration und Nutzung liegt bei Ihnen.")
	return /** @type {LocalizedString} */ ("You are responsible for configuration and usage of the Guardrails feature.")
});